<script>
import { mapGetters, mapActions } from "vuex";
import adminMastersList from "~/src/components/AdminMastersList.vue";

export default {
  components: { adminMastersList },

  data: (vm) => ({
    tab: Number(vm.$route.query.tab) || 0,
    isLoading: false,
  }),

  created() {   
    this.INIT_COUNT();
  },

  computed: {
    ...mapGetters("admin-masters", ["GET_COUNT"]),
    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  methods: {
    ...mapActions("admin-masters", ["INIT_COUNT"]),

    onTap(tab) {
      window.open(`?tab=${tab}`, "_blank");
    },
  },
};
</script>

<template>
  <div>
    <v-container v-if="isSupperAdmin" fluid>
      <div class="_cards-wrap">
        <div>
          <v-card class="mx-auto" dark color="#288FDA" elevation="0">
            <v-card-text>
              <div class="card-title" v-text="$t('All Contract')" />
              <div class="card-count">{{ GET_COUNT.ALL | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#e62d2d" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Not Paid Contract") }}</div>
              <div class="card-count">{{ GET_COUNT.NOT_PAID | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="orange" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Half Paid Contract") }}</div>
              <div class="card-count">{{ GET_COUNT.HALF_PAID | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#26d316" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Paid Contract") }}</div>
              <div class="card-count">{{ GET_COUNT.PAID | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-card class="position-relative" outlined>
            <v-tabs v-model="tab" color="accent">
              <v-tab
                @click.ctrl="onTap(0)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('All Contract')"
              />
              <v-tab
                @click.ctrl="onTap(1)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Not Paid Contract')"
              />
              <v-tab
                @click.ctrl="onTap(2)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Half Paid Contract')"
              />
              <v-tab
                @click.ctrl="onTap(3)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Paid Contract')"
              />
            </v-tabs>

            <admin-masters-list
              @loading="(v) => (isLoading = v)"
              v-model="tab"
            />
          </v-card>
        </v-col>
        <!-- <div >
        <v-btn small color="primary">EXEL EXPORT</v-btn>
      </div> -->
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.card-title {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.527);

  margin-bottom: 20px;
  padding-bottom: 10px;

  font-weight: 500;
  font-size: 18px;

  text-transform: uppercase;

  text-align: center;
}

.card-count {
  font-size: 24px;
  font-weight: 500;

  color: white;

  text-align: center;
}

.card-table {
  width: 100%;
  box-shadow: 0px 2px 4px rgba(128, 128, 128, 0.267);
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.right-form {
  padding: 15px 15px 10px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.right-form div {
  width: 300px;
  height: 60px;
}

._cards-wrap {
  @media only screen and (max-width: 1200px) {
    > div {
      margin: 20px 0;
    }
  }

  @media only screen and (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
